import documentReady from '@awaitbox/document-ready';
import onLoaded from "onloaded";
import html2canvas from "html2canvas";

let instance;
let outOfViewPortContainer;
let debugPng;
let isRendering = false;

const dppx = window.devicePixelRatio;

const showDebugPng = false;

async function getOutOfViewPortContainer()
{
    if (outOfViewPortContainer) return outOfViewPortContainer;
    
    outOfViewPortContainer = document.createElement("div");
    outOfViewPortContainer.setAttribute("style", "position: absolute; left: 5000px; top: 0; width: 1000px; height: 1000px;");
    document.body.appendChild(outOfViewPortContainer);

    if (showDebugPng) {
        debugPng = document.createElement("img");
        debugPng.setAttribute("style", "position: absolute; left: 0; top: 0; ");
        document.body.appendChild(debugPng);
    }
    
    return outOfViewPortContainer;
}

async function registerRendering() {
    const poll = resolve => {
        if(isRendering === false) {
            isRendering = true;
            resolve();
        }
        else setTimeout(() => poll(resolve), 1000);
    }
    return new Promise(poll);
}

async function allImagesLoaded(element) {
    
    const numImages = element.getElementsByTagName('img');
    if (numImages.length === 0) {
        return true;
    }
    
    return new Promise((resolve, reject) => {
        onLoaded(element, {
            onComplete() {
                resolve(true);
            }
        });
    });
}

class HtmlRenderer {
    constructor() {
        if (instance) {
            throw new Error('New instance cannot be created');
        }
        instance = this;
    }

    async render(html)
    {
        await documentReady();
        let outOfViewPortContainer = await getOutOfViewPortContainer();
        await registerRendering();
        
        let htmlContainer = document.createElement("div");
        htmlContainer.setAttribute("style", "display: inline-block");
        htmlContainer.innerHTML = html;
        outOfViewPortContainer.append(htmlContainer);
        
        await allImagesLoaded(htmlContainer);

        console.time('html2canvas');
        const canvas = await html2canvas(htmlContainer,{
            scale: 1,
            logging: false,
            backgroundColor: null,
            width: htmlContainer.firstChild.offsetWidth,
            height: htmlContainer.firstChild.offsetHeight,
        });
        console.timeEnd('html2canvas');
        
        if (showDebugPng) {
            debugPng.src = canvas.toDataURL();
        }

        htmlContainer.remove();

        isRendering = false;

        return canvas;
    }
}

let htmlRenderer = Object.freeze(new HtmlRenderer());

export default htmlRenderer;